import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import HistoryDialog from "../UserTimeline/TimelineItem/HistoryDialog";
import { getLabelId } from "./moodboardModel";

export default function ChooseLabels({
  variant,
  initTable,
  selectedLabels,
  handleSelectLabels,
  initialSelectedLabels,
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false); // open the table with labels and questions
  const handleOpen = () => setOpen(true);
  const handleClose = (selected) => {
    setOpen(false);
    handleSelectLabels(selected);
  };
  const table =
    variant === "timeline"
      ? initTable // view all labels in the timeline,
      : initTable.filter((row) =>
          initialSelectedLabels.includes(getLabelId(row.labelProps))
        ); // view only a subset in the moodboards

  return (
    <div>
      {variant !== "analyser" ? (
        <Button onClick={handleOpen}>
          {t("timeline.buttons.chooseLabels")}
        </Button>
      ) : null}
      {open ? (
        <HistoryDialog
          onClose={handleClose}
          table={table}
          open={open}
          labels={selectedLabels}
        />
      ) : null}
    </div>
  );
}
